import React from "react";
// import ZeroAcknow from '../../component/security/ZeroKnowledge'
import ZeroKnowledge from "../../component/security/ZeroKnowledge";
import SecurityOps from "../../component/security/SecurityOps";
import UptimeSection from "../../component/security/UptimeSection";
import SharedResponsibility from "../../component/security/SharedResponsibility";
import CTASection from "../../component/security/CTASection";
import HeaderMenu from "../../component/Navbar/headermenu";
import CustomFooter from "../../component/Footer/customFooter";
// import HeroSection from "../../component/security/SecurityHeroSection";
import SecurityHeroSection from "../../component/security/SecurityHeroSection";
import ProtectWorkSection from "../../component/security/ProtectWorkSection";
import SecurityLayersSection from "../../component/security/SecurityLayersSection";
import SecureJourneySection from "../../component/security/SecureJourneySection";
import TrustStatement from "../../component/security/TrustStatement";
import Security_Indian_Compliance_Framework from "../../component/security/Security_Indian_Compliance_Framework";
import PrivacyAccess from "../../component/security/PrivacyAccess";
import DataLocation from "../../component/security/DataLocation";
import IncidentResponse from "../../component/security/IncidentResponse";
import ReliabilityContinuity from "../../component/security/ReliabilityContinuity";
import SharedSecurity from "../../component/security/SharedSecurity";
import FAQSection from "../../component/security/FAQSection";

const SecurityPage = () => {
  return (
    <div>
      <HeaderMenu />
      <SecurityHeroSection />
      <TrustStatement />
      <ProtectWorkSection />
      <SecurityLayersSection />
      <SecureJourneySection />
      <ZeroKnowledge />
      {/* <Security_Indian_Compliance_Framework /> */}
      <PrivacyAccess />
      {/* <DataLocation /> */}
      <IncidentResponse />
      <ReliabilityContinuity />
      <SharedSecurity />
      <CTASection />
      <CustomFooter />
    </div>
  );
};
{
  /* <FAQSection /> */
}

export default SecurityPage;
